import { createFileRoute } from '@tanstack/react-router';

import { SetNewPasswordPage } from '../login/pages/SetNewPasswordPage';

export const Route = createFileRoute('/set-new-password')({
    component: SetNewPasswordPage,
});
